class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const introductionstrSwiper = new Swiper('.introductionstr-swiper', { // ←全introductionstrの部分固有名に変える
      loop: true, // ←trueがon、falseがoff
      slidesPerView: 'auto', // ←表示数
      spaceBetween: 16, // ←間隔(gap)
      centeredSlides: true, // ←センタースライド
      // slidesOffsetBefore: 18,
      // slidesOffsetAfter: 18,
    
    
      pagination: {
        el: '.introductionstr-swiper-pagination',
      },
      navigation: {
        nextEl: '.introductionstr-swiper-button-next',
        prevEl: '.introductionstr-swiper-button-prev',
      },
    });
    const introductionproSwiper = new Swiper('.introductionpro-swiper', { // ←全introductionproの部分固有名に変える
      loop: true, // ←trueがon、falseがoff
      slidesPerView: 'auto', // ←表示数
      spaceBetween: 16, // ←間隔(gap)
      centeredSlides: true, // ←センタースライド
      // slidesOffsetBefore: 18,
      // slidesOffsetAfter: 18,
    
    
      pagination: {
        el: '.introductionpro-swiper-pagination',
      },
      navigation: {
        nextEl: '.introductionpro-swiper-button-next',
        prevEl: '.introductionpro-swiper-button-prev',
      },
    });


    $(function(){
      $('.faq-list li').click(function(){  //←囲んでる要素
        $(this).find('.a-wrap').slideToggle();  //←開閉したい要素
        $(this).toggleClass('is-open');  //←囲んでる要素にis-openクラスを切り替え
      });
      // ↓ 最初の囲んでる要素は開閉しておく設定 ↓
      $('.faq-list li:first-child').addClass('is-open').find('.a-wrap').show();
    });


    const mvSwiper = new Swiper('.mv-swiper', { // ←全mvの部分固有名に変える
      loop: true, // ←trueがon、falseがoff
      loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
      slidesPerView: 1, // ←表示数
      centeredSlides: true, // ←センタースライド
      effect: 'fade', // ←追加 フェード機能をONにする
    
      speed: 2000, // ←切り替わるときの動きのスピード
      autoplay: { // ←自動再生
        delay: 3000, // 次のスライドに切り替わるまでの時間を指定(40秒)
        disableOnInteraction: false, // ←false にすればユーザーがドラッグなどの操作をしても自動再生が止まらない
      },
    });

    // 画面縦中央が .fade-item 上端より下に来たら is-inview を付与
    let fadeItemInviewRaf = null;
    const updateFadeItemInview = () => {
      const viewportMid = window.innerHeight / 2;
      document.querySelectorAll('.p-top .fade-item').forEach((node) => {
        if (node.getBoundingClientRect().top < viewportMid) {
          node.classList.add('is-inview');
        }
      });
    };
    const scheduleFadeItemInview = () => {
      if (fadeItemInviewRaf !== null) return;
      fadeItemInviewRaf = requestAnimationFrame(() => {
        fadeItemInviewRaf = null;
        updateFadeItemInview();
      });
    };
    $(window).on('scroll.fadeItemInview resize.fadeItemInview', scheduleFadeItemInview);
    scheduleFadeItemInview();
  }
}
